import { PieChart } from '@mui/x-charts/PieChart';
import { useEffect, useState } from 'react';


function NutritionChart({ details }) {
    const [smallSize, setSmallSize] = useState(false)
    const palette = ['#FFD700', '#AFEEEE', '#6B8E23', '#FA8072']
    useEffect(() => {
        // Function to update the window width
        const handleResize = () => {
            if (window.innerWidth < 700) {
                setSmallSize(true)
            } else {
                setSmallSize(false)
            }
        };

        handleResize()

        // Attach the resize event listener
        window.addEventListener('resize', handleResize);

        // Clean up the event listener on unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const valueFormatter = (item) => `${item.value} g`;
    return (
        <div>
            <PieChart
                height={233}
                margin={{ right: 0, top: 0, bottom: 0, left: 0 }}

                slotProps={{ legend: { hidden: true } }}
                colors={palette}
                series={[
                    {
                        data: details,
                        highlightScope: { fade: 'global', highlight: 'item' },
                        paddingAngle: 1,
                        cornerRadius: 33,
                        innerRadius: 100,
                        arcLabelMinAngle: 20,
                        valueFormatter: valueFormatter,

                    },
                ]}
            />
        </div>
    );
}


export default NutritionChart;